import { Link } from "react-router-dom";
import logoAetna from "@/assets/logo-aetna.svg";
import logoBcbs from "@/assets/logo-bcbs.svg";
import logoCigna from "@/assets/logo-cigna.svg";
import logoUhc from "@/assets/logo-uhc.svg";

const insuranceLogos = [
  { src: logoAetna, alt: "Aetna" },
  { src: logoBcbs, alt: "Blue Cross Blue Shield" },
  { src: logoCigna, alt: "Cigna" },
  { src: logoUhc, alt: "United Healthcare" },
];

const Footer = () => {
  return (
    <footer
      className="site-footer py-20 px-6 border-t border-border"
      style={{ backgroundColor: "#2F4D55", color: "#E1EFF3" }}
    >
      <div className="max-w-5xl mx-auto">
        {/* Licenses */}
        <div className="footer-licenses text-center mb-14">
          <h3 className="font-heading font-medium text-sm uppercase tracking-wider mb-5" style={{ color: "#E1EFF3" }}>
            Licenses & Insurance
          </h3>
          <div className="font-body text-sm space-y-2" style={{ color: "#E1EFF3" }}>
            <p>TX LMFT #205960</p>
            <p>CA LMFT #136159</p>
            <p>NPI #1700446150</p>
          </div>
        </div>

        {/* Insurance Logos */}
        <div className="footer-insurance-logos flex items-center justify-center gap-10 md:gap-14 mb-14 flex-wrap">
          {insuranceLogos.map((logo) => (
            <img key={logo.alt} src={logo.src} alt={logo.alt} className="h-8 w-auto opacity-40 brightness-200" />
          ))}
        </div>

        <div className="w-16 h-px mx-auto mb-10" style={{ backgroundColor: "#E1EFF3", opacity: 0.3 }} />

        {/* Land acknowledgement */}
        <p
          className="font-body text-xs text-center max-w-xl mx-auto mb-10 leading-relaxed"
          style={{ color: "#E1EFF3", opacity: 0.6 }}
        >
          Stillwater Therapy acknowledges that we live and work on the traditional lands of Indigenous peoples. We honor
          their enduring connection to this land and commit to supporting equity and healing for all communities.
        </p>

        {/* Bottom row */}
        <div
          className="footer-bottom flex flex-col items-center justify-between gap-5 font-body text-sm"
          style={{ color: "#E1EFF3" }}
        >
          <p className="footer-copyright">© {new Date().getFullYear()} Stillwater Therapy. All rights reserved.</p>
          <div className="footer-legal-links flex flex-wrap justify-center gap-8">
            <a
              href="https://bhec.texas.gov/tbhec/discipline-and-complaints/how-to-file-a-complaint/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 opacity-70 hover:opacity-100 transition-opacity"
            >
              File a Complaint
            </a>
            <Link
              to="/cancellation-policy"
              className="underline underline-offset-2 opacity-70 hover:opacity-100 transition-opacity"
            >
              No-Show &amp; Cancellation Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
